import { createAsyncThunk } from '@reduxjs/toolkit'
import MobileLoginProxyConfirmation from './mobile-login-proxy-confirmation-model'
import {
  delete_mobileLoginProxyConfirmation,
  load_mobileLoginProxyConfirmations,
  store_mobileLoginProxyConfirmation,
} from './mobileLoginProxyConfirmation-service'

export const LoadMobileLoginProxyConfirmationsAsync = createAsyncThunk<
  any,
  any
>(
  'composer/load/mobileLoginProxyConfirmation',
  async (params: { uid: string }) => {
    return await load_mobileLoginProxyConfirmations(params)
  },
)

export const CreateMobileLoginProxyConfirmationAsync = createAsyncThunk<
  any,
  any
>(
  'composer/create/mobileLoginProxyConfirmation',
  async (params: MobileLoginProxyConfirmation) => {
    return await store_mobileLoginProxyConfirmation(params)
  },
)

export const DeleteMobileLoginProxyConfirmationAsync = createAsyncThunk<
  any,
  any
>('composer/delete/mobileLoginProxyConfirmation', async (params) => {
  return await delete_mobileLoginProxyConfirmation(params)
})
